import { useRef } from 'react';
import { useButton } from '@react-aria/button';
import I18n from 'I18n';
import { getFileTypeIcon } from './utils';
export function useFileAttachmentCard(fileMetadata) {
  const {
    url,
    displayName,
    extension,
    type,
    fileSize
  } = fileMetadata;
  const buttonRef = useRef(null);
  const {
    buttonProps
  } = useButton({
    onPress: () => window.open(url, '_blank', 'noopener,noreferrer')
  }, buttonRef);
  return {
    buttonRef,
    buttonProps,
    ariaLabel: I18n.text('conversations-visitor-ui.spotlight.fileAttachmentCard.open', {
      name: displayName
    }),
    FileIconComponent: getFileTypeIcon(type, extension),
    extensionLabel: extension ? extension.toUpperCase() : null,
    displayName,
    fileSize
  };
}